export default function getAbsoluteUrl(href) {
  return `https://apphud.com${href}`
}
